import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route changes start at the top; hash links keep their section destination.
export function RouteScrollReset() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    root.style.scrollBehavior = previous;
  }, [pathname, hash]);

  return null;
}